!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@material-ui/core"), require("@material-ui/styles")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core", "@material-ui/styles"], t) : t((e = e || self)["linear-progress-overlay"] = {}, e.React, e.core, e.styles);
}(this, function (e, t, r, o) {
  "use strict";

  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;

  var _n = function n() {
    return (_n = Object.assign || function (e) {
      for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);

      return e;
    }).apply(this, arguments);
  };

  e.LinearProgressOverlay = function (e) {
    var i = e.isLoading,
        a = e.transitionDelay,
        l = void 0 === a ? 0 : a,
        s = e.fullScreen,
        c = e.opacity,
        u = function (e, t) {
      var r = {};

      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;

        for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
      }

      return r;
    }(e, ["isLoading", "transitionDelay", "fullScreen", "opacity"]),
        y = o.useTheme();

    if (!y) throw new Error("LinearProgressOverlay must be within a Theme Provider");
    return i ? t.createElement(r.Box, {
      zIndex: s ? y.zIndex.tooltip + 1 : y.zIndex.modal - 1,
      position: s ? "fixed" : "absolute",
      top: 0,
      left: 0,
      height: 1,
      width: 1,
      style: {
        backgroundColor: "rgba(255,255,255," + (void 0 !== c ? c : .75) + ")"
      }
    }, t.createElement(r.Fade, {
      in: i,
      style: {
        transitionDelay: i ? l + "ms" : "0ms"
      }
    }, t.createElement(r.Box, {
      height: 1,
      width: 1,
      display: "flex",
      justifyContent: "center"
    }, t.createElement(r.LinearProgress, _n({
      color: "primary",
      style: _n(_n({}, u.style), {
        flexGrow: 1
      })
    }, u))))) : null;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});